module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-container mb-20"
  }, [_c('video', {
    attrs: {
      "controls": "",
      "disablepictureinpicture": "",
      "controlsList": "nodownload"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.video.name
    }
  })]), _vm._v(" "), _c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "submit",
      "disabled": _vm.smallLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.downloadCheckListVideo(_vm.video)
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t("button.download")) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-686a9f16"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/bookings/details/ChecklistVideo.vue
// module id = 1396
// module chunks = 0